import { render, staticRenderFns } from "./MateriaTable.vue?vue&type=template&id=42972557&"
import script from "./MateriaTable.vue?vue&type=script&lang=js&"
export * from "./MateriaTable.vue?vue&type=script&lang=js&"
import style0 from "./MateriaTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports